import React from 'react';
import styles from './SummaryBox.module.scss';
import { Box } from 'modules/af_cm_ui_kit/components';
import ErrorMessage from 'shared/Messages/ErrorMessage';

type Props = {
  data: Array<{
    title: string;
    value: string;
    errorMessage: string | undefined;
  }>;
};

const SummaryBox: React.FC<Props> = ({ data }) => {
  return (
    <Box>
      <div className={styles.summaryBox}>
        {data.map((item, index) => (
          <div className={styles.rightBorder} key={`summary-box-${index}`}>
            {<h3>{item.title}</h3>}
            <span>{item.value}</span>
            {item.errorMessage && <ErrorMessage message={item.errorMessage} />}
          </div>
        ))}
      </div>
    </Box>
  );
};

export default SummaryBox;
